import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import Steps from './Steps/Steps';

import styles from './Transfer.module.scss';

const LegendContext = React.createContext();

const Transfer = ({ headers, steps, legend }) => {
  const params = {
    info: [2, 7, 8, 10],
    dashed: [3, 4, 5, 7, 9, 13],
    optional: [3],
    selected: [6],
    wa: [2, 4, 5, 13, 14],
    sellers: [2, 3, 14],
    buyers: [2, 12, 14],
    bank: [10],
    natar: [7, 8, 9, 10, 11],
  };

  const stepsProps = {
    steps,
    params,
    legend
  };

  return (
    <BaseSection {...headers} anchor="transfer"
      additionalClass={styles.section}
    >
      <div className={styles.Transfer}>
        <LegendContext.Provider value={ legend } >
          <Steps {...stepsProps} />
        </LegendContext.Provider>
      </div>
    </BaseSection>
  );
};

export { LegendContext };

export default Transfer;
